import { render, staticRenderFns } from "./Clip.vue?vue&type=template&id=fcda3b80"
import script from "./Clip.vue?vue&type=script&lang=js"
export * from "./Clip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcda3b80')) {
      api.createRecord('fcda3b80', component.options)
    } else {
      api.reload('fcda3b80', component.options)
    }
    module.hot.accept("./Clip.vue?vue&type=template&id=fcda3b80", function () {
      api.rerender('fcda3b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Clip.vue"
export default component.exports